import { useEffect } from "react";
import {
  TemplateTaskActionButton,
  PrebuiltTemplateTaskActionButton,
  PrebuitTaskTemplateActionButtonParentProps,
  TaskTemplateActionButtonParentProps,
} from "./TemplateTaskActionButton";
import TaskTemplateMessagePromptForm, { DisplayPrebuiltTaskTemplateMessagePrompt } from "../TaskTemplateMessagePromptForm";

export default function TemplateMessagePromptTaskAction({ form, autoOpen, setAutoOpen, onRemove }: TaskTemplateActionButtonParentProps) {
  useEffect(() => {
    if (autoOpen) {
      setAutoOpen(false);
    }
  }, [autoOpen, setAutoOpen]);
  return (
    <TemplateTaskActionButton autoOpen={autoOpen} onRemove={onRemove} buttonText="Prompt User To Send Message" buttonTitle="Prompt User To Send Message" modalSize="3xl">
      <TaskTemplateMessagePromptForm form={form} />
    </TemplateTaskActionButton>
  );
}

export function PrebuiltTemplateMessagePromptTaskAction({ prebuiltTaskTemplate }: PrebuitTaskTemplateActionButtonParentProps) {
  return (
    <PrebuiltTemplateTaskActionButton buttonText="Email Input" buttonTitle="Email Input">
      <DisplayPrebuiltTaskTemplateMessagePrompt prebuiltTaskTemplate={prebuiltTaskTemplate} />
    </PrebuiltTemplateTaskActionButton>
  );
}
